module.exports = __webpack_public_path__ + "img/excelImg.ba528c16.png";